// Off Canvas panel scripts

jQuery(document).ready(function($) {

	// Add the no-scroll class to the body if either the off-canvas form or mobile navigation is opened

	$('.wex-nav-toggle, a[data-toggle="wex-offCanvasContact"]').click( function() {
		$('body').addClass("no-scroll");
	} );

	$('.wex-link--cta').click(function() {
		if ( $(this).attr('target') !== '_blank') {
			$('body').addClass('no-scroll');
		}
	});

	// Removes the no-scroll class from the body if the off-canvas panel or mobile navigation's, "X" is clicked, or the overlay itself is clicked.
	$('.wex-close-panel, .js-off-canvas-overlay, .wex-mobile-nav-close').click( function() {
		$('body').removeClass("no-scroll");
	} );

	// Resizing the browser will also remove the no-scroll class. That is found in mega-menu.js

});